let messages = {};

//Make sure messages are no longer then 10 characters including spacebars!
messages.good = ["Damn", "Nice", "Awesome", "Cool", "Gu mooi"];
messages.incredible = ["WTF!!", "Moette zien!", "Nondeju"];
export default messages;